import { render, staticRenderFns } from "./ver_evidencias_gestionconvenio.vue?vue&type=template&id=48b33eec&scoped=true"
import script from "./ver_evidencias_gestionconvenio.vue?vue&type=script&lang=js"
export * from "./ver_evidencias_gestionconvenio.vue?vue&type=script&lang=js"
import style0 from "./ver_evidencias_gestionconvenio.vue?vue&type=style&index=0&id=48b33eec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b33eec",
  null
  
)

export default component.exports